import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { chartColors, getSizeColor } from "../../../config/constantsColor";

// Utility: Convert "YYYY-MM-DD HH:mm:ss" to UTC timestamp
const parseDate = (dateString) => {
    const date = new Date(dateString);
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
};

const ProductBarChart = ({ data, sizeData }) => {

    // 🔍 Step 1: Collect all unique sizes dynamically
    const allSizesSet = new Set();
    data?.daily_size_data?.forEach(item => {
        Object.keys(item.size_counts || {}).forEach(size => allSizesSet.add(size));
    });
    const allSizes = Array.from(allSizesSet);

    // 🎯 Step 2: Create series for each size
    const series = allSizes.map((size, index) => ({
        name: size,
        color: getSizeColor(size, sizeData),
        // color: chartColors[size + '"'],
        data: data?.daily_size_data?.map(item => [
            parseDate(item.DATE_KEY),
            item.size_counts?.[size] || 0
        ])
    }));

    // 📊 Highcharts options
    const options = {
        chart: {
            type: "column",
            height: 390,
            zoomType: "x",
        },
        title: {
            text: "Product Over Product",
            align: "left",
            style: {
                fontSize: "18px",
                fontWeight: "500",
                color: "#001323",
            },
            margin: 30,
        },
        xAxis: {
            type: "datetime",
            lineWidth: 0,
            tickLength: 0,
            minorTickLength: 0,
            labels: {
                format: "{value:%d/%m/%Y}",
                style: {
                    fontSize: '12px',
                    color: '#333'
                }
            },
            scrollbar: {
                enabled: true,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: "Count",
                style: {
                    fontSize: "18px",
                    fontWeight: "400",
                    color: "#001323",
                },
            },
            gridLineColor: "#E0E0E0",
        },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                let s = `<b>${Highcharts.dateFormat('%d/%m/%Y', this.x)}</b><br/>`;
                this.points.forEach(point => {
                    s += `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${point.y}</b><br/>`;
                });
                return s;
            }
        },
        plotOptions: {
            column: {
                stacking: "normal",
                pointPadding: 0.2,
                groupPadding: 0.1,
                borderRadius: 4,
                borderWidth: 0,
            },
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
        series: series,
    };

    return (
        <div className="product-bar-chart-container">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default ProductBarChart;
